import { useState, useEffect } from 'react'
import ChartMenu, { MenuRow, MenuSwatch, MenuWeight, MenuNumber, MenuDivider, MenuActions, MenuButton } from './menu/ChartMenu'

// ============================================
// ATRTrailSettingsMenu — the ATR Trailing Stop's toolbar.
//
// Frame, fit, outside-click/Esc and every style come from menu/ChartMenu and
// the CHART MENUS block in styles.css (this used to carry its own copy of
// the S/R toolbar CSS).
//
// Layout mirrors S/R: one horizontal row of controls, dividers between
// groups, an action row underneath. Bull/Bear use the shared ColorPicker,
// weight is the same dropdown with line previews, and the ATR maths live in
// three compact numeric fields. Still STAGED: nothing reaches the chart
// until APPLY (unchanged behaviour).
// ============================================

const LINE_WEIGHTS = [1, 2, 3, 4]

export default function ATRTrailSettingsMenu({ show, x, y, openLeft, config, onUpdate, onHide, onClose }) {
  const [bullCol, setBullCol] = useState(config?.bullCol || '#26de81')
  const [bearCol, setBearCol] = useState(config?.bearCol || '#fc5c65')
  const [weight,  setWeight]  = useState(config?.weight  || 2)
  const [atrPeriod, setAtrPeriod] = useState(config?.atrPeriod ?? 5)
  const [hhvPeriod, setHhvPeriod] = useState(config?.hhvPeriod ?? 10)
  const [mult, setMult] = useState(config?.mult ?? 2.5)

  useEffect(() => {
    if (show && config) {
      setBullCol(config.bullCol); setBearCol(config.bearCol)
      setWeight(config.weight); setAtrPeriod(config.atrPeriod)
      setHhvPeriod(config.hhvPeriod); setMult(config.mult)
    }
  }, [show, config])

  const handleApply = () => {
    onUpdate({
      bullCol, bearCol,
      weight: Number(weight) || 2,
      atrPeriod: Math.max(2, parseInt(atrPeriod) || 5),
      hhvPeriod: Math.max(2, parseInt(hhvPeriod) || 10),
      mult: Math.max(0.5, parseFloat(mult) || 2.5),
    })
    onClose()
  }

  if (!show) return null

  return (
    <ChartMenu anchor={{ x, y }} openLeft={openLeft} onClose={onClose}>
      <MenuRow>
        <MenuSwatch label="BULL" value={bullCol} onChange={setBullCol} />
        <MenuDivider />
        <MenuSwatch label="BEAR" value={bearCol} onChange={setBearCol} />
        <MenuDivider />
        <MenuWeight value={weight} weights={LINE_WEIGHTS} onChange={setWeight} />
      </MenuRow>

      {/* ATR maths row — staged into local state, committed by APPLY */}
      <MenuRow>
        <MenuNumber label="ATR" value={atrPeriod} min={2} max={100} delay={0} onCommit={setAtrPeriod} />
        <MenuDivider />
        <MenuNumber label="HHV" value={hhvPeriod} min={2} max={200} delay={0} onCommit={setHhvPeriod} />
        <MenuDivider />
        <MenuNumber label="MULT" value={mult} float step={0.1} min={0.5} max={10} delay={0} onCommit={setMult} />
      </MenuRow>

      <MenuActions>
        <MenuButton variant="danger" onClick={() => { onHide(); onClose() }}>HIDE</MenuButton>
        <MenuButton variant="primary" onClick={handleApply}>APPLY</MenuButton>
      </MenuActions>
    </ChartMenu>
  )
}
